var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderFacebookLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2450_2273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4419 0.486633H4.55814C2.04075 0.486633 0 2.52738 0 5.04477V37.9285C0 40.4459 2.04075 42.4866 4.55814 42.4866H37.4419C39.9593 42.4866 42 40.4459 42 37.9285V5.04477C42 2.52738 39.9593 0.486633 37.4419 0.486633Z",
    fill: "#E7B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6738 17.7424H18.0692V16.9285C18.0692 15.6262 17.9064 13.9983 18.0692 12.6959C18.232 9.60291 19.8599 7.64942 24.0924 7.48663L28.325 7.64942V12.2076C26.5343 12.2076 23.4413 11.5564 23.1157 13.8355V17.7424H27.9994L27.511 22.789H23.1157V35.4866H18.0692V22.789L13.6738 22.6262V17.7424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0005 21.3238L28.3261 7.64941V12.2076C26.5354 12.2076 23.4424 11.5564 23.1168 13.8355V17.7424H28.0005L27.5122 22.789H23.1168V35.4866H18.0703L25.0703 42.4866H37.4424L42.0005 37.9285V21.3238Z",
    fill: "#E7B556"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2450_2273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.486633)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderFacebookLogo);
export default __webpack_public_path__ + "static/media/header_facebook_logo.87b6c6a11e43b3402ae8e4d7a31b2708.svg";
export { ForwardRef as ReactComponent };